import Link from 'next/link';

// Mock data - API ready
const features = [
    {
        id: 1,
        title: 'Verified Properties',
        description: 'All listings are verified for authenticity and accurate pricing',
        icon: 'verified',
    },
    {
        id: 2,
        title: 'Expert Guidance',
        description: 'Get professional advice from our real estate experts',
        icon: 'expert',
    },
    {
        id: 3,
        title: 'Transparent Pricing',
        description: 'No hidden costs or brokerage surprises',
        icon: 'transparent',
    },
    {
        id: 4,
        title: 'Wide Coverage',
        description: '100+ cities covered across India',
        icon: 'coverage',
    },
    {
        id: 5,
        title: 'Easy Process',
        description: 'Simplified buying and selling journey',
        icon: 'easy',
    },
    {
        id: 6,
        title: '24/7 Support',
        description: 'Round the clock customer assistance',
        icon: 'support',
    },
];

const iconMap = {
    verified: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
    ),
    expert: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
    ),
    transparent: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
    ),
    coverage: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    ),
    easy: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
    ),
    support: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
    ),
};

const stats = [
    { label: 'Properties Listed', value: '50,000+' },
    { label: 'Happy Customers', value: '10,000+' },
    { label: 'Cities Covered', value: '100+' },
    { label: 'Expert Agents', value: '500+' },
];

const WhyChooseUs = () => {
    return (
        <section className="py-8 lg:py-12">
            <div className="container-custom">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    {/* Left Content */}
                    <div>
                        <div className="section-title">
                            {/* <span className="subtitle">Why DreamAcres</span> */}
                            <h2>Your Trusted Real Estate Partner</h2>
                            <p>
                                We've helped thousands of families find their dream homes.
                                Here's why customers choose us over others.
                            </p>
                        </div>

                        {/* Features Grid */}
                        <div className="grid sm:grid-cols-2 gap-6 mt-8">
                            {features.map((feature) => (
                                <div key={feature.id} className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                                        {iconMap[feature.icon]}
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-900 mb-1">
                                            {feature.title}
                                        </h4>
                                        <p className="text-sm text-gray-600">
                                            {feature.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CTA */}
                        <div className="mt-10">
                            <Link href="/about" className="btn btn-primary">
                                Learn More About Us
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </Link>
                        </div>
                    </div>

                    {/* Right - Stats Card */}
                    <div className="relative">
                        <div className="card-static p-8 lg:p-10">
                            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary/10 rounded-full blur-2xl" />
                            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />

                            <div className="relative">
                                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                                    Our Journey So Far
                                </h3>

                                <div className="grid grid-cols-2 gap-6">
                                    {stats.map((stat, idx) => (
                                        <div key={idx} className="text-center p-4 rounded-xl bg-gray-50">
                                            <div className="text-3xl lg:text-4xl font-bold text-primary mb-1">
                                                {stat.value}
                                            </div>
                                            <div className="text-sm text-gray-600">
                                                {stat.label}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* CTA for Sellers */}
                                <div className="mt-8 p-6 rounded-xl bg-gradient-to-br from-primary to-primary-light text-white">
                                    <h4 className="text-lg font-semibold mb-2">
                                        Are You a Property Owner?
                                    </h4>
                                    <p className="text-white/80 text-sm mb-4">
                                        List your property for FREE and reach thousands of potential buyers.
                                    </p>
                                    <Link
                                        href="/sell/post-property"
                                        className="btn btn-white inline-flex"
                                    >
                                        Post Property FREE
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
